import { render, staticRenderFns } from "./SelfEmployedStep.vue?vue&type=template&id=5822347e&"
import script from "./SelfEmployedStep.vue?vue&type=script&lang=js&"
export * from "./SelfEmployedStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports